import { Box } from '@mui/material';
import styled from 'styled-components';

import {
  TDataTablePaperProps,
  TNameContainerProps,
} from '@/shared/components/ui/data-table/data-table.types';
import { Paper } from '@/shared/components/ui/paper/paper.styled';

export const DataTablePaper = styled(Paper)<TDataTablePaperProps>`
  && {
    border-radius: ${({ theme }) => theme.shape.containerRadius};
    display: flex;
    height: 100%;
    min-height: 0;
    flex-direction: column;
    box-shadow: ${({ theme, $isInnerPage }) =>
      $isInnerPage
        ? 'none;'
        : `0 1px 0 0 ${theme.palette.stroke.secondaryLight}, // Bottom
           1px 0 0 0 ${theme.palette.stroke.secondaryLight}, // Left
           -1px 0 0 0 ${theme.palette.stroke.secondaryLight}; // Right
       `};

    .ag-cell-value {
      .custom-tag {
        align-self: flex-start;
      }
    }
  }
`;

export const NameContainer = styled(Box)<TNameContainerProps>`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  width: 100%;

  span {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    span {
      text-decoration: ${({ $clickable }) =>
        $clickable ? 'underline' : 'none'};
    }
  }

  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'initial')};
`;
